'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LIST_ITEM = exports.LIST_ITEM = 'COrganismListItem';
var FORM = exports.FORM = 'COrganismForm';
var MEDIA_GRID = exports.MEDIA_GRID = 'COrganismMediaGrid';
var CAROUSEL = exports.CAROUSEL = 'COrganismCarousel';
var CAROUSEL_ARROW = exports.CAROUSEL_ARROW = 'COrganismCarouselArrow';
var CAROUSEL_CONTROLS = exports.CAROUSEL_CONTROLS = 'COrganismCarouselControls';
var INTERACTION_LIST = exports.INTERACTION_LIST = 'COrganismInteractionList';
var QUESTION = exports.QUESTION = 'COrganismQuestion';